import { render, staticRenderFns } from "./InboundSMSList.vue?vue&type=template&id=4b50e36a&scoped=true&"
import script from "./InboundSMSList.vue?vue&type=script&lang=js&"
export * from "./InboundSMSList.vue?vue&type=script&lang=js&"
import style0 from "./InboundSMSList.vue?vue&type=style&index=0&id=4b50e36a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b50e36a",
  null
  
)

export default component.exports